import i18n from 'react-native-i18n';
import en from './locale/en';
import fr from './locale/fr';

i18n.fallbacks = true;

i18n.translations = {
    en,
    fr
};

export default i18n;